import { render, staticRenderFns } from "./VideosDownload.vue?vue&type=template&id=1a4ec3e2&scoped=true"
import script from "./VideosDownload.vue?vue&type=script&lang=js"
export * from "./VideosDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4ec3e2",
  null
  
)

export default component.exports